import { render, staticRenderFns } from "./OverviewDescription.vue?vue&type=template&id=f1bbc520&scoped=true"
import script from "./OverviewDescription.vue?vue&type=script&lang=js"
export * from "./OverviewDescription.vue?vue&type=script&lang=js"
import style0 from "./OverviewDescription.vue?vue&type=style&index=0&id=f1bbc520&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bbc520",
  null
  
)

export default component.exports